import { ErrorBoundary } from "react-error-boundary";

import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/useAuth";
import {
  FALLBACK_ERROR_MESSAGE,
  NO_PERM_ERROR_MESSAGE,
  SD_EMAIL,
} from "@/lib/constants";
import { PATH } from "@/lib/enums";
import { useLocation, useNavigate } from "react-router-dom";
//@ts-ignore
export const QueryBoundary = ({ children }) => (
  <ErrorBoundary
    onReset={() => {
      window.location.reload();
    }}
    FallbackComponent={ErrorView}
  >
    {children}
  </ErrorBoundary>
);

// Error + retry
//@ts-ignore
const ErrorView = ({ error, resetErrorBoundary }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { signOut } = useAuth();

  // Defensive: error may be undefined
  const err = error || {};
  console.error("error view: an error occurred");

  const isPermError = !!(
    (err && err.response?.status === 403) ||
    err.message === NO_PERM_ERROR_MESSAGE
  );
  const isNotFoundError = !!(
    err &&
    (err.status === 404 || err.response?.status === 404)
  );
  const isAuthError = !!(
    err &&
    (err.status === 401 || err.response?.status === 401)
  );

  let errorMessage;
  if (isPermError) {
    errorMessage = NO_PERM_ERROR_MESSAGE;
  } else if (isNotFoundError) {
    errorMessage = "Not found";
  } else if (isAuthError) {
    // Instead of await, use .then()
    signOut()
      .then(() => {
        navigate(PATH.LOGIN);
        // window.location.reload();
      })
      .catch(() => {
        console.error("Sign out failed on auth error");
        navigate(PATH.LOGIN);
      });
    errorMessage = FALLBACK_ERROR_MESSAGE;
  } else {
    errorMessage = FALLBACK_ERROR_MESSAGE;
  }

  const handleLogout = () => {
    signOut()
      .then(() => navigate(PATH.LOGIN))
      .catch(() => {
        console.error("Sign out failed");
        navigate(PATH.LOGIN);
      });
  };
  return (
    <div className="container mx-auto w-screen">
      <div className="flex items-center justify-center pt-10">
        {errorMessage}
      </div>
      <div className="flex items-center justify-center flex-row gap-4 pt-4">
        {!isPermError && !isNotFoundError && (
          <Button onClick={resetErrorBoundary}>Retry</Button>
        )}
        <Button
          variant="outline"
          onClick={() => {
            if (location.pathname === PATH.HOME) {
              handleLogout();
              navigate(PATH.LOGIN);
              window.location.reload();
            } else {
              navigate(PATH.HOME);
              window.location.reload();
            }
          }}
        >
          Back home
        </Button>{" "}
        <div className="text-center text-muted-foreground text-sm">
          <a href={`mailto:${SD_EMAIL}`} className=" underline-offset-4">
            Need help?
          </a>
        </div>{" "}
      </div>
      {/* {!isPermError && !isNotFoundError && (
        <div className="w-screen flex items-center justify-center  gap-4">
          If this error persists please contact our support with this reference:
          <div className="flex items-center justify-center flex-col pt-10">
            <a href={`mailto:${SD_EMAIL}`}>{SD_EMAIL}</a>
            <a href={STATUS_URL}>Status Page</a>
          </div>
        </div>
      )} */}
    </div>
  );
};
